import styled from 'styled-components'
import { brandOrange } from '../../../assets/consts/color'
import ImageCut from '../../../assets/images/graphic_imageCut.svg'

export const ImageWrapper = styled.div`
  position: relative;
  flex-grow: 1;
  flex-shrink: 0;

  &:before {
    content: '';
    background-image: url(${ImageCut});
    background-position: top left;
    background-size: cover;
    height: 30px;
    left: -1px;
    position: absolute;
    top: -1px;
    transform: rotate(180deg);
    width: 30px;
    z-index: 1;
  }
`
export const Container = styled.div`
  position: relative;
  padding: 0;
  gap: 24px;
  flex-wrap: wrap;
  justify-content: start;

  &.col-xs-12 {
    padding: 0;
  }

  @media only screen and (min-width: 48em) {
    gap: 24px;
    flex-wrap: nowrap;

    .author-avatar-sm {
      width: 116px;
      flex-grow: 1;
      flex-shrink: 0;
    }

    .author-info-sm {
    }
  }

  .margin-xs-16 {
    margin-bottom: 16px;

    & > div {
      margin-bottom: 0;
    }
  }

  @media only screen and (min-width: 64em) {
    .margin-md-24 {
      margin-bottom: 24px;
    }
  }

  @media only screen and (min-width: 90em) {
    gap: 24px;
    &.col-lg-10 {
      padding: 0;
    }
  }

  & > div {
    padding: 0;

    @media only screen and (min-width: 48em) {
      &.col-sm-9 {
        flex-shrink: 1;
      }
    }

    @media only screen and (min-width: 64em) {
      &.col-md-9 {
        flex-shrink: 1;
      }
    }
  }

  & > div:nth-of-type(2) {
    @media only screen and (min-width: 90em) {
      h3 {
        font-size: 18px;
      }

      h2 {
        font-size: 32px;
      }
    }

    & > p {
      @media only screen and (min-width: 90em) {
        font-size: 16px;
      }
    }
  }

  /* &:before {
    background-color: ${brandOrange};
    content: '';
    height: 100%;
    left: 0;
    position: absolute;
    width: 4px;
  } */
`
